import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountResponse } from 'src/app/models/account.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';
import { TransferTokenService } from 'src/app/services/transfer-token.service';

@Component({
  selector: 'app-bam-query-account-status',
  templateUrl: './bam-query-account-status.component.html',
  styleUrls: ['./bam-query-account-status.component.scss']
})
export class BamQueryAccountStatusComponent implements OnInit {
  accounts: AccountResponse[] = [];
  filterAccounts: AccountResponse[] = [];
  filterAccountsDebit: AccountResponse[] = [];
  selectedOwnAccount: string | null = null;
  years: number[] = [];
  months: { value: number; label: string }[] = [];
  selectedYear!: number;
  selectedMonth!: number;
  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth() + 1; // 1-12
  loading = false;
  confirmModalVisible = false;
  showInputCode = false;
  loadingSendCode = false;
  code2fa = '';
  accountStatusPreview: any = null;

  constructor(private toastService: ToastrService, private accountService: AccountService, private bamTransferService: BamTransferServiceService, private transferTokenService: TransferTokenService) { }

  ngOnInit(): void {
    this.getBanksOwn();
    this.generateYears();
    this.selectedYear = this.currentYear;
    this.updateMonths();
  }

  getBanksOwn() {
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data;
        this.filterAccounts = this.accounts.filter(account => account.bank == 4);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  generateYears() {
    for (let y = this.currentYear; y >= 1990; y--) {
      this.years.push(y);
    }
  }

  updateMonths() {
    const allMonths = [
      { value: 1, label: 'Enero' },
      { value: 2, label: 'Febrero' },
      { value: 3, label: 'Marzo' },
      { value: 4, label: 'Abril' },
      { value: 5, label: 'Mayo' },
      { value: 6, label: 'Junio' },
      { value: 7, label: 'Julio' },
      { value: 8, label: 'Agosto' },
      { value: 9, label: 'Septiembre' },
      { value: 10, label: 'Octubre' },
      { value: 11, label: 'Noviembre' },
      { value: 12, label: 'Diciembre' }
    ];

    if (this.selectedYear === this.currentYear) {
      // excluir mes actual
      this.months = allMonths.filter(m => m.value < this.currentMonth);
    } else {
      this.months = allMonths;
    }

    // reset si el mes seleccionado ya no es válido
    if (!this.months.find(m => m.value === this.selectedMonth)) {
      this.selectedMonth = this.months.length ? this.months[0].value : 0;
    }
  }

  getAccountStatus() {
    if (!this.selectedOwnAccount || !this.selectedYear || !this.selectedMonth) {
      return;
    }

    if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    const data = {
      bankAccountNumber: this.selectedOwnAccount,
      year: this.selectedYear,
      month: this.selectedMonth,
      token: this.code2fa
    };

    this.loading = true;

    this.bamTransferService.getAccountStatus(data).subscribe({
      next: (response: ResponseObject) => {
        if (!response.data.result.statement_url) {
          this.toastService.warning("Al parecer no se encontraron registros.");
          this.loading = false;
          this.resetTokenState();
          return;
        }

        this.loading = false;
        this.resetTokenState();

        const a = document.createElement('a');
        a.href = response.data.result.statement_url;
        a.download = 'archivo.pdf';
        a.click();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener estado de cuenta");
        this.loading = false;
      }
    });
  }

  openPdf(url: string) {
    window.open(url, '_blank');
  }

  openConfirmModal() {
    if (!this.selectedOwnAccount || !this.selectedYear || !this.selectedMonth) {
      this.toastService.error('Debes seleccionar cuenta, año y mes antes de continuar');
      return;
    }

    const account = this.filterAccounts.find(
      acc => String(acc.accountNumber) === String(this.selectedOwnAccount)
    );

    const month = this.months.find(
      m => Number(m.value) === Number(this.selectedMonth)
    );

    this.accountStatusPreview = {
      account,
      year: this.selectedYear,
      month: month ? month.label : this.selectedMonth
    };

    this.confirmModalVisible = true;
  }

  onConfirmAccountStatus() {
    if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    this.confirmModalVisible = false;
    this.getAccountStatus();
  }

  onCancelAccountStatus() {
    this.confirmModalVisible = false;
    this.resetTokenState();
  }

  sendRequestCode() {
    this.loadingSendCode = true;

    this.transferTokenService.createTokenTransfer().subscribe({
      next: (_response: ResponseObject) => {
        this.showInputCode = true;
        this.loadingSendCode = false;
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al solicitar token');
        this.loadingSendCode = false;
      }
    });
  }

  async pastClipboard() {
    try {
      this.code2fa = await navigator.clipboard.readText();
    } catch (error) {
      console.error('No se pudo leer el portapapeles', error);
      this.toastService.error('No se pudo leer el portapapeles');
    }
  }

  resetTokenState() {
    this.loadingSendCode = false;
    this.showInputCode = false;
    this.code2fa = '';
  }

}
